import React, {Component} from "react";
import DataManager from "../../DataManagers/DataManager";
import {Modal} from "antd";
import {LinkWithIcon} from "../MapHoverTooltipLayer";
import USASpendingDataTable from "./USASpendingDataTable";
import OpenUSASpendingButton from './OpenUSASpendingButton'


export class USASpendingDataModalAndButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			usaSpendingData: {
				// fields: {},
				// rows: []
			},
			countyFIPSCodeForFetchedUsaSpendingData: '',
		}
	}
	
	showModal = () => {
		this.setState({
			visible: true,
		})
	}
	
	handleCancel = () => {
		this.setState({
			visible: false
		})
	}
	
	handleClickUSASpendingButton = () => {
		this.showModal()
		const {countyFIPSCode} = this.props
		const countyFIPSCodeHasChanged = this.props.countyFIPSCodeForFetchedUsaSpendingData !== countyFIPSCode
		
		if (!this.state.usaSpendingData.rows || countyFIPSCodeHasChanged) {
			DataManager.stats.getUSASpendingDataPromiseFor(countyFIPSCode).then(res => {
				this.setState({
					usaSpendingData: res[0].data,
					countyFIPSCodeForFetchedUsaSpendingData: countyFIPSCode,
				})
			})
		}
	}
	
	render() {
		const {countyFIPSCode, selectedGeography, ...modalProps} = this.props
		const {usaSpendingData} = this.state
		
		return (
			<div>
				<Modal
					title={(<div className={'map-expanded-menu-header usa-spending-data-modal-title'}>
						<div className="big-bold-header-text">Federal grants awarded</div>
						{' from October 1st, 2017 - September 30th, 2019 for the county'}</div>)}
					wrapClassName={'usa-spending-modal'}
					width={'85vw'}
					footer={null}
					{...modalProps}
					
					visible={this.state.visible}
					onCancel={this.handleCancel}
				
				>
					<div className="usa-spending-data-modal-description">
						{`Source: USA Spending. `}
						<LinkWithIcon href={'https://www.usaspending.gov/#/'}>USA Spending tracks federal spending</LinkWithIcon>
						{' to ensure taxpayers can see how their money is being used in communities across America.'}
					</div>
					<USASpendingDataTable usaSpendingData={usaSpendingData}/>
				</Modal>
				
				<OpenUSASpendingButton onClick={this.handleClickUSASpendingButton} selectedGeography={selectedGeography} />
			</div>
		)
	}
}
